import styled from 'styled-components';

export const Outer = styled.div`
  overflow: hidden;
  transition: height 250ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
